import AxiosOICStat from "../AxiosOICStat";
import { getLang } from "./countriesApi";

const TBF_BASE = "/tbf";

export type TbfDirection = "top" | "bottom";

export interface TbfRankingRequest {
  cCodes: number[];
  direction: TbfDirection;
  position: number;
}

export interface TbfRankingRow {
  c_code: number;
  ind_code: number;
  indicator: string | null;
  category: string | null;
  unit: string | null;
  year: number;
  value: number;
  rank: number;
  rank_to: number;
  ranked_countries: number;
}

export interface TbfRankingResponse {
  direction: TbfDirection;
  position: number;
  first_year: number;
  last_year: number;
  min_countries: number;
  results: TbfRankingRow[];
}

export async function fetchTbfRanking(
  { cCodes, direction, position }: TbfRankingRequest,
  lang: string = getLang()
): Promise<TbfRankingResponse> {
  const response = await AxiosOICStat.get<TbfRankingResponse>(`${TBF_BASE}/ranking`, {
    params: { c_codes: cCodes, direction, position, lang },
    paramsSerializer: { indexes: null },
  });
  return response.data;
}
